<template>
    <canvas :width='canvasWidth' :height='canvasHeight' id='imagePixelGrid' ref='imagePixelGrid' :style='canvasStyle' />
</template>
<script>

import utilityService from '../mixins/utilityService.js'

export default {
    // https://stackoverflow.com/questions/40410332/vuejs-access-child-components-data-from-parent
    // https://stackoverflow.com/questions/45478035/start-range-in-v-for-n-in-10-from-zero
    props: {
        rowsCount: { // expected to be an odd number, center item is highlighted selection
            type: Number,
            required: true
        },
        columnsCount: { // expected to be an odd number, center item is highlighted selection
            type: Number,
            required: true
        },
        cellPixelSize: {
            type: Number,
            required: true
        },
        colorsArray: { // row major 2-dimensional colors array
            type: Array,
            required: true
        },
        locationX: {
            type: Number,
            required: true
        },
        locationY: {
            type: Number,
            required: true
        },
        renderingKey: {
            type: String,
            required: true
        }
    },
    mixins: [utilityService],
    components: {
    },
    data() {
        return {
            vueCanvas: null
        }
    },
    methods: {
        renderGrid() {
            // console.log('in renderGrid()')

            for (let row=0; row < this.rowsCount; row++) {
                for (let col=0; col < this.columnsCount; col++) {
                    let rgbColor = this.colorsArray[row][col]
                    let colorFillStyle = 'rgb(' + rgbColor.R + ',' + rgbColor.G + ',' + rgbColor.B + ')'
                    this.vueCanvas.fillStyle = colorFillStyle
                    let startX = (this.cellPixelSize * col)
                    let startY = (this.cellPixelSize * row)
                    this.vueCanvas.fillRect(startX, startY, this.cellPixelSize, this.cellPixelSize)
                }
            }

            // now color draw a hightlight border around the center cell
            let centerRow = Math.floor(this.rowsCount / 2)
            let centerCol = Math.floor(this.columnsCount / 2)

            let centerColor = this.colorsArray[centerRow][centerCol]

            let inverseCenterColorRed = {}
            let inverseCenterColorGreen = {}
            let inverseCenterColorBlue = {}

            let perceivedBrightness = this.getPerceivedBrightness(centerColor)

            if (perceivedBrightness < 128) {
                inverseCenterColorRed = 192
                inverseCenterColorGreen = 192
                inverseCenterColorBlue = 192
            }
            else {
                inverseCenterColorRed = 64
                inverseCenterColorGreen = 64
                inverseCenterColorBlue = 64
            }
            let inverseCenterColorFillStyle = 'rgb(' + inverseCenterColorRed + ',' + inverseCenterColorGreen + ',' + inverseCenterColorBlue + ')'

            this.vueCanvas.fillStyle = inverseCenterColorFillStyle

            let centerStartX = this.cellPixelSize * centerCol
            let centerStartY = this.cellPixelSize * centerRow

            this.vueCanvas.fillStyle = inverseCenterColorFillStyle
            this.vueCanvas.fillRect(centerStartX-1, centerStartY-1, this.cellPixelSize+2, 1) // horiz top
            this.vueCanvas.fillRect(centerStartX-1, centerStartY + this.cellPixelSize-1+1, this.cellPixelSize+2, 1) // horiz bottom
            this.vueCanvas.fillRect(centerStartX-1, centerStartY-1, 1, this.cellPixelSize+2) // vert left
            this.vueCanvas.fillRect(centerStartX + this.cellPixelSize, centerStartY-1, 1, this.cellPixelSize+2) // vert right
        },

        pixelYFromRowNum(rowNum) {
            return rowNum * this.cellPixelSize
        },

        pixelXFromColNum(colNum) {
            return colNum * this.cellPixelSize
        },

        rowNumFromPixelY(y) {
            return Math.trunc(y / this.cellPixelSize)
        },

        colNumFromPixelX(x) {
            return Math.trunc(x / this.cellPixelSize)
        },

        getPerceivedBrightness(color) {
            // return (0.21 * color.R) + (0.72 * color.G) + (0.07 * color.B)
            return (color.R + color.G + color.B) / 3
        }
    },

    watch: {
    },
    computed: {
        canvasWidth: function() {
            let cw = (this.columnsCount * this.cellPixelSize)
            // console.log('canvasWidth: ' + cw)
            return cw
        },

        canvasHeight: function() {
            let ch = (this.rowsCount * this.cellPixelSize)
            // console.log('canvasHeight: ' + ch)
            return ch
        },

        canvasStyle: function() {
            let canvasDynamicStyle = 'pointer-events: none; position: absolute; left: ' + this.locationX + 'px; top: ' + this.locationY + 'px; z-index: 20; width: ' + this.canvasWidth + 'px; height: ' + this.canvasHeight + 'px;'
            // console.log('canvasStyle: ' + canvasDynamicStyle)
            return canvasDynamicStyle
        }
    },
    created() {
    },
    mounted() {
        let c = this.$refs['imagePixelGrid']
        let ctx = c.getContext('2d')
        this.vueCanvas = ctx

        // Create circular clipping region
        ctx.beginPath()
        let centerX = this.canvasWidth / 2
        let centerY = this.canvasHeight / 2
        let radius = this.canvasWidth / 2
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2)
        ctx.clip()
        this.renderGrid()
    },
    updated() {
        this.renderGrid()
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ImagePixelGrid.vue